import { DeviceConfig, DeviceTypes, AllConfig } from "../config";
import { AlertRecord } from "../alert";
import { StateMap } from "./Types";
import * as Status from "../status";
import PoolDeviceTypes, { PoolDeviceClassBase } from "./devicetype";
import logger from "../utils/Logger";

export { default as PoolDeviceTypes } from "./devicetype";
export * as Types from "./Types";

/**
 * Returns PoolDevice
 * @param deviceType 
 * @returns E.g:
 * ```javascript
 * {
 *     default: {}, // The PooldDvice class
 *     criticalFieldIdentifiers: {}, // Optional
 *     PoolsideDaemonDeviceStateNames: {}, // Optional
 * }
 * ```
 */
export function getPoolDeviceClass<K extends DeviceTypes>(deviceType: K): (typeof PoolDeviceTypes)[K] | typeof PoolDeviceClassBase {
    const PoolDeviceClass = PoolDeviceTypes[ deviceType ];
    if (!PoolDeviceClass) {
        return PoolDeviceClassBase;
    }
    return PoolDeviceClass;
}


export function getPoolDeviceInstance(deviceConfig: DeviceConfig, deviceStates: StateMap, siteStates: {}, allConfigs: AllConfig, allAlerts: AlertRecord[], allStates: Status.State[])  {
    const PoolDeviceClass = getPoolDeviceClass(deviceConfig.DeviceType);
    return new PoolDeviceClass.default(deviceConfig, deviceStates, siteStates, allConfigs, allAlerts, allStates);
}
